/*
 * slider/index.js
 *
 * This file contains the default setup for slick slider and provides a method to initlise new carousels
 * with these GS FED Boilerplate defaults. This component is designed to be included with other components, see usage
 * below:
 *
 * import slider from '../slider';
 *
 * let customOpts = { yourCustomOpts }
 * slider('.my-custom-slider-class', customOpts);
 *
 */
import $ from 'jquery';
import 'slick-carousel';

// Create slick carousel on the passed in element and option values
function createSlider(element, customOpts) {
    const $sliderContainer = $(element).children('.slider-container');
    const $slider = $(element).find('.inner');

    // Early return if the slider is already initialised, no need to do it again
    if ($slider.hasClass('slick-initialized')) {
        return;
    }

    // GS FED Boilerplate default options for the slider, best not change these!
    const slickDefaults = {
        mobileFirst: true,
        appendArrows: $sliderContainer,
        appendDots: $sliderContainer,
        dots: true,
        speed: 300,
        prevArrow: '<button type="button" role="button" class="slick-prev slick-arrow"><svg class="svg-icon"><use xlink:href="#chevron-left" /></svg><span>Previous</span></button>',
        nextArrow: '<button type="button" role="button" class="slick-next slick-arrow"><span>Next</span> <svg class="svg-icon"><use xlink:href="#chevron-right" /></svg></button>'
    };

    // Extend the defaults for your specific purpose
    const slickOpts = Object.assign(slickDefaults, customOpts);
    $slider.slick(slickOpts);
}

function slider(elem, customOpts = {}) {
    // Find the custom element
    // NOTE: Always prefixed with c-slider
    const $component = $(`.c-slider.${elem}`);

    // Init all the sliders on the page one at a time
    $component.each(function () {
        const sliderElement = this;
        createSlider(sliderElement, customOpts);
    });
}

export default slider;
